import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";
import { SunLogo } from "./SunLogo";
import { LangSwitcher } from "./LangSwitcher";
import { useLang } from "../i18n";

const IDS = ["sobre-nosotros", "carta", "favoritos", "galeria", "visitanos", "reserva"];

export const Nav = () => {
  const [solid, setSolid] = useState(false);
  const [open, setOpen] = useState(false);
  const { t } = useLang();

  useEffect(() => {
    const onScroll = () => setSolid(window.scrollY > 80);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (id) => {
    setOpen(false);
    document.getElementById(id)?.scrollIntoView({ behavior: "smooth" });
  };

  return (
    <header
      data-testid="site-nav"
      className={`v1-top-nav fixed inset-x-0 top-0 z-50 transition-colors duration-500 ${
        solid ? "bg-[#2B1E16]/95 backdrop-blur-md" : "bg-transparent"
      }`}
    >
      <div className="v1-top-nav__inner mx-auto flex max-w-[1400px] items-center justify-between px-6 py-4 md:px-12 md:py-6">
        <button
          data-testid="nav-logo"
          onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
          dir="ltr"
          className="brand-lockup flex items-center gap-3 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B98A]"
          aria-label={t.nav.home}
        >
          <SunLogo animate={false} className="h-6 w-auto" />
          <span className="brand-latin font-sans text-xs uppercase tracking-[0.42em] text-[#F5EDE3]">Deseos</span>
        </button>

        <nav className="hidden items-center gap-6 md:flex lg:gap-8 xl:gap-10">
          {IDS.map((id) => (
            <button
              key={id}
              data-testid={`nav-link-${id}`}
              onClick={() => go(id)}
              className="group relative font-sans text-[12px] uppercase tracking-[0.22em] text-[#F5EDE3]/80 transition-colors duration-300 hover:text-[#F5EDE3] focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-[#D9B98A]"
            >
              {t.nav.links[id]}
              <span className="absolute -bottom-1.5 left-0 h-[1px] w-0 bg-[#D9B98A] transition-all duration-500 ease-out group-hover:w-full" />
            </button>
          ))}
          <LangSwitcher className="ms-2 border-s border-[#D9B98A]/25 ps-6" />
        </nav>

        <div className="flex items-center gap-4 md:hidden">
          <LangSwitcher />
          <button
            data-testid="nav-mobile-toggle"
            onClick={() => setOpen((v) => !v)}
            className="text-[#D9B98A]"
            aria-label={t.nav.menu}
          >
            {open ? <X size={26} /> : <Menu size={26} />}
          </button>
        </div>
      </div>

      {open && (
        <div data-testid="nav-mobile-panel" className="border-t border-[#D9B98A]/20 bg-[#2B1E16] px-6 pb-8 pt-4 md:hidden">
          {IDS.map((id) => (
            <button
              key={id}
              data-testid={`nav-mobile-link-${id}`}
              onClick={() => go(id)}
              className="block w-full py-3 text-start font-serif text-[28px] text-[#F5EDE3]"
            >
              {t.nav.links[id]}
            </button>
          ))}
        </div>
      )}
    </header>
  );
};
